import React from 'react';
import { ArrowRight, Download, Github, Linkedin, Mail } from 'lucide-react';
import { NavigationSection } from '../types/NavigationSection';
import animeMyself from '../assets/animeMyself.png';
import resume from '../assets/GeneralCV2.pdf';
import Navbar from './NavBar';

const Hero: React.FC = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center pt-16 overflow-hidden selection:bg-fuchsia-900 selection:text-white-900">
      {/* Navbar */}
        <Navbar/>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center text-center">
        <div className="inline-block mb-4 px-4 py-1.5 rounded-full bg-green-200 border border-green-200 text-yellow-700 text-sm font-black cursor-pointer group relative">
          Available for Hire
          {/* Coffee + Steam Container - appears on hover */}
          <div className="absolute left-1/2 transform -translate-x-1/2 -translate-y-1 opacity-0 group-hover:opacity-100 transition-all duration-500 ease-out flex flex-col items-center pointer-events-none">
            
            {/* STEAM SECTION 
              We use absolute positioning to make them start from inside the cup 
            */}
            <div className="relative w-full flex justify-center mb-1">
              {/* Wisp 1 (Left) */}
              <div className="absolute bottom-0 -ml-3 w-1.5 h-6 bg-gray-200 rounded-full blur-[2px] opacity-0 animate-steam origin-bottom"></div>
              {/* Wisp 2 (Center - slightly delayed) */}
              <div className="absolute bottom-0 w-1.5 h-6 bg-gray-200 rounded-full blur-[2px] opacity-0 animate-steam [animation-delay:0.4s] origin-bottom"></div>
              {/* Wisp 3 (Right - more delayed) */}
              <div className="absolute bottom-0 -mr-3 w-1.5 h-6 bg-gray-200 rounded-full blur-[2px] opacity-0 animate-steam [animation-delay:0.8s] origin-bottom"></div>
            </div>

            {/* REALISTIC CUP SVG 
              Using paths for curves and ellipses for depth 
            */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-12 h-12 drop-shadow-lg" /* Increased size slightly for detail */
              viewBox="0 0 64 64"
              fill="none"
            >
              {/* Saucer (Shadow) */}
              <ellipse cx="32" cy="54" rx="20" ry="4" fill="#000" fillOpacity="0.2" />

              {/* Cup Handle */}
              <path d="M46 26C51 26 55 29 55 34C55 39 51 42 46 42" stroke="#FFF" strokeWidth="4" strokeLinecap="round" />

              {/* Cup Body (White Ceramic) */}
              <path d="M16 22V36C16 44.8 23.16 52 32 52C40.84 52 48 44.8 48 36V22" fill="white" />
              
              {/* Cup Rim/Liquid Surface (This creates the 3D effect) */}
              <g>
                {/* Outer Rim */}
                <ellipse cx="32" cy="22" rx="16" ry="5" fill="#EEE" /> 
                {/* Coffee Liquid (Dark Brown) */}
                <ellipse cx="32" cy="22" rx="13" ry="4" fill="#4B2C20" />
                {/* Coffee Reflection (Shiny bit) */}
                <path d="M36 21C36 21 34 23 30 23" stroke="white" strokeWidth="1" strokeOpacity="0.3" strokeLinecap="round" />
              </g>
            </svg>
          </div>
        </div>
        
        <br/>
              
        <h1 className="text-4xl sm:text-6xl md:text-7xl font-extrabold tracking-tight text-white mb-6">
          Building Digital <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-200 to-accent">Solutions</span>
          <br /> That Matter.
        </h1>
        
        <p className="mt-4 max-w-2xl text-xl text-gray-700 font-extrabold mb-4">
          Martin Yuan
        </p>
        
        <img 
          src={animeMyself}
          alt="A personal anime version profile selfie"
          className="h-auto max-w-32 mb-4"
        />

        <div className="flex flex-col sm:flex-row gap-4 justify-center w-full sm:w-auto">
          <a 
            href={`${NavigationSection.ABOUT}`}
            className="inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-lg text-white bg-accent hover:bg-[#2F3B22] transition-colors md:text-lg shadow-lg shadow-green-900/20"
          >
            About me
            <ArrowRight className="ml-2 -mr-1 h-5 w-5" />
          </a>
          <a 
            href={resume}
            download="MartinYuan-CV.pdf"
            className="inline-flex items-center justify-center px-8 py-3 border border-slate-600 text-base font-medium rounded-lg text-gray-300 bg-slate-800/50 hover:bg-slate-800 transition-colors md:text-lg backdrop-blur-sm"
          >
            Download CV
            <Download className="ml-2 -mr-1 h-5 w-5" />
          </a>
        </div>

        <div className="mt-12 flex space-x-6">
          <a href="https://github.com/HuntMartin" className="text-gray-300 hover:text-white transition-colors">
            <span className="sr-only">GitHub</span>
            <Github className="h-8 w-8" />
          </a>
          <a href="https://www.linkedin.com/in/martin-yuan-7365712b6" className="text-gray-300 hover:text-white transition-colors">
            <span className="sr-only">LinkedIn</span>
            <Linkedin className="h-8 w-8" />
          </a>
          <a href="mailto:target-xbox00735@gmail.com" className="text-gray-300 hover:text-white transition-colors">
            <span className="sr-only">Email</span>
            <Mail className="h-8 w-8" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;